import React, { memo } from 'react';
import styled from 'styled-components';

export const DisclaimerStyled = styled.div`
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
  font-size: ${({ theme }) => theme.kallisto.font.size['150']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['200']};
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  margin-bottom: 16px;
  width: 100%;
`;

type DisclaimerProps = {
  hide: boolean;
  text: string;
};

const Disclaimer = memo(
  ({ hide, text }: DisclaimerProps) => {
    if (hide) return null;

    return <DisclaimerStyled>{text}</DisclaimerStyled>;
  },
  (prevProps: DisclaimerProps, nextProps: DisclaimerProps) => {
    if (prevProps.hide !== nextProps.hide) return false;
    if (prevProps.text !== nextProps.text) return false;
    return true;
  }
);

Disclaimer.displayName = 'Disclaimer';

export default Disclaimer;
